import React from 'react';

const Edit = ({ fill = '#404040' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="path-1-outside-1_2691_2577"
      maskUnits="userSpaceOnUse"
      x="2.09983"
      y="2.80747"
      width="19.0919"
      height="19.0919"
      fill="black"
    >
      <rect
        fill="white"
        x="2.09983"
        y="2.80747"
        width="19.0919"
        height="19.0919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7775 5.63589L18.3633 4.22168L17.6562 4.92879L19.0704 6.343L19.7775 5.63589ZM18.3633 7.05011L16.9491 5.63589L4.92825 17.6567V19.0709H6.34247L18.3633 7.05011Z"
      />
    </mask>
    <path
      d="M18.3633 4.22168L19.0704 3.51457L18.3633 2.80747L17.6562 3.51457L18.3633 4.22168ZM19.7775 5.63589L20.4846 6.343L21.1917 5.63589L20.4846 4.92879L19.7775 5.63589ZM17.6562 4.92879L16.9491 4.22168L16.242 4.92879L16.9491 5.63589L17.6562 4.92879ZM19.0704 6.343L18.3633 7.05011L19.0704 7.75721L19.7775 7.05011L19.0704 6.343ZM16.9491 5.63589L17.6562 4.92879L16.9491 4.22168L16.242 4.92879L16.9491 5.63589ZM18.3633 7.05011L19.0704 7.75721L19.7775 7.05011L19.0704 6.343L18.3633 7.05011ZM4.92825 17.6567L4.22115 16.9496L3.92825 17.2425L3.92825 17.6567H4.92825ZM4.92825 19.0709H3.92825L3.92825 20.0709L4.92825 20.0709L4.92825 19.0709ZM6.34247 19.0709L6.34247 20.0709L6.75668 20.0709L7.04957 19.778L6.34247 19.0709ZM17.6562 4.92879L19.0704 6.343L20.4846 4.92879L19.0704 3.51457L17.6562 4.92879ZM18.3633 5.63589L19.0704 4.92879L17.6562 3.51457L16.9491 4.22168L18.3633 5.63589ZM19.7775 5.63589L18.3633 4.22168L16.9491 5.63589L18.3633 7.05011L19.7775 5.63589ZM19.0704 4.92879L18.3633 5.63589L19.7775 7.05011L20.4846 6.343L19.0704 4.92879ZM16.242 6.343L17.6562 7.75721L19.0704 6.343L17.6562 4.92879L16.242 6.343ZM5.63536 18.3638L17.6562 6.343L16.242 4.92879L4.22115 16.9496L5.63536 18.3638ZM5.92825 19.0709V17.6567H3.92825V19.0709H5.92825ZM6.34247 18.0709H4.92825L4.92825 20.0709H6.34247L6.34247 18.0709ZM17.6562 6.343L5.63536 18.3638L7.04957 19.778L19.0704 7.75721L17.6562 6.343Z"
      fill="black"
      mask="url(#path-1-outside-1_2691_2577)"
    />
  </svg>
);

export default Edit;
